<div class="main-panel-content h-100">
    <!--SHOW CONTENT ON DESKTOP-->
    <!-- <div class=""> -->
    <div class="p-2 px-2 mt-2 d-none d-sm-none d-md-block vh-90" *ngIf="!isMobile">
        <app-search-section *ngIf="!articleExpanded && !hideforGyan && !showGyanOrganisation && !showSaveDraftList"></app-search-section>
        <div *ngIf="showDashboardHome && !showGyanOrganisation">
            <app-dashboard-home></app-dashboard-home>
        </div>
        <div *ngIf="!showDashboardHome && showGyanOrganisation">
            <div *ngIf="showSubmitGyan; else showOrganisation">
                <app-submit-gyan></app-submit-gyan>
            </div>
            <ng-template #showOrganisation>
                <app-gyan-organisation [recentSearchesList]="allGyanList" [isTopicLoading]="isLoading"></app-gyan-organisation>
            </ng-template>
        </div>
        <div *ngIf="!showDashboardHome && !showGyanOrganisation && showSaveDraftList">
            <app-draft-list></app-draft-list>
        </div>
        <div
            *ngIf="!showDashboardHome && !showGyanOrganisation && !showSaveDraftList"
            [ngClass]="articleExpanded || hideforGyan ? 'main-content-without-searchbar' : 'main-content'"
        >
            <div class="container-fluid h-100">
                <div class="row h-100">
                    <div class="col-sm-8" [ngClass]="articleExpanded ? 'p-0' : 'p-3 pt-0'" [@expandCollapse]="articleExpanded ? 'collapsed' : 'expanded'">
                        <app-multi-doc-summary-section
                            *ngIf="!articleExpanded"
                            [PreviousGyanId]="PreviousgyanId"
                            (clickbackdata)="receiveClickbackList($event)"
                            (clickbackparaids)="receiveClickbackparas($event)"
                            [gyanStatusfromSocket]="gyanStatusfromSocket"
                        ></app-multi-doc-summary-section>
                    </div>
                    <div class="col-sm-4">
                        <div class="search-title" (click)="showMDS()" *ngIf="articleExpanded">
                            <div class="back-arrow-left"></div>
                            <span class="gyanSearchSectionTitle" title="{{ GyanName }}">{{ GyanName }}</span>
                        </div>
                        <div class="text-end" style="margin-bottom: 20px" *ngIf="!articleExpanded && hideforGyan">
                            <!-- <span class="createnewgyanbtn" (click)="createGysnBtnClick()" [attr.id]="'go-creategyantbn'" [attr.data-test]="'go-creategyantbn'">Create Gyan</span> -->
                            <button (click)="createGysnBtnClick()" class="custom-create-gyan-btn float-end" [attr.id]="'go-creategyantbn'" [attr.data-test]="'go-creategyantbn'">
                                <div class="create-gyan-plus-icon"></div>
                                Create Gyan
                            </button>
                            <div class="clear"></div>
                        </div>
                        <app-articles-section
                            *ngIf="!clickBackArticleList"
                            (subscriptionMessageModal)="onsubscriptionMessageModal($event)"
                            [PreviousGyanId]="PreviousgyanId"
                            [articleExpanded]="articleExpanded"
                        ></app-articles-section>
                        <app-articles-section
                            *ngIf="clickBackArticleList"
                            [PreviousGyanId]="PreviousgyanId"
                            [clickBackArticleList]="clickBackArticleList"
                            [clickBackparaids]="clickbackparas"
                            [articleExpanded]="articleExpanded"
                            (subscriptionMessageModal)="onsubscriptionMessageModal($event)"
                        ></app-articles-section>
                    </div>
                    <div class="col-sm-8 p-0" *ngIf="articleExpanded">
                        <div *ngIf="showArticleNetworkGraph">
                            <app-article-network-graph></app-article-network-graph>
                        </div>
                        <div class="h-100" *ngIf="!showArticleNetworkGraph">
                            <app-article-long-story [longStoryData]="longStoryData" [paraClickId]="paraClickId"></app-article-long-story>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- </div> -->

    <!--SHOW CONTENT ON MOBILE-->
    <div class="d-sm-block d-md-none" *ngIf="isMobile">
        <app-search-section *ngIf="!articleExpanded && !hideforGyan && !showGyanOrganisation && !showSaveDraftList"></app-search-section>
        <div *ngIf="showDashboardHome && !showGyanOrganisation">
            <app-dashboard-home></app-dashboard-home>
        </div>
        <div *ngIf="!showDashboardHome && showGyanOrganisation">
            <div *ngIf="showSubmitGyan; else showOrganisation">
                <app-submit-gyan></app-submit-gyan>
            </div>
            <ng-template #showOrganisation>
                <app-gyan-organisation [recentSearchesList]="allGyanList" [isTopicLoading]="isLoading"></app-gyan-organisation>
            </ng-template>
        </div>
        <div *ngIf="!showDashboardHome && !showGyanOrganisation && showSaveDraftList">
            <app-draft-list></app-draft-list>
        </div>
        <div
            *ngIf="!showDashboardHome && !showGyanOrganisation && !showSaveDraftList"
            [ngClass]="articleExpanded || hideforGyan ? 'main-content-without-searchbar' : 'main-content'"
        >
            <div class="container-fluid h-100">
                <div class="row h-100" *ngIf="!showDashboardHome">
                    <div class="col-12 p-2 pt-0 h-100">
                        <owl-carousel-o [options]="customOptions" #owlCarousel (translated)="onTranslated($event)">
                            <ng-template carouselSlide>
                                <div *ngIf="!articleExpanded && hideforGyan" class="row button-mobile-margin-bottom-10px">
                                    <div class="text-end button-mobile-right">
                                        <button
                                            (click)="createGysnBtnClick()"
                                            class="custom-create-gyan-btn float-end"
                                            [attr.id]="'go-creategyantbn'"
                                            [attr.data-test]="'go-creategyantbn'"
                                        >
                                            <div class="create-gyan-plus-icon"></div>
                                            Create Gyan
                                        </button>
                                        <div class="clear"></div>
                                        <!-- <span class="createnewgyanbtn">Create Gyan</span> -->
                                    </div>
                                </div>
                                <div class="row">
                                    <app-multi-doc-summary-section
                                        [PreviousGyanId]="PreviousgyanId"
                                        (clickbackdata)="receiveClickbackList($event)"
                                        (clickbackparaids)="receiveClickbackparas($event)"
                                        [gyanStatusfromSocket]="gyanStatusfromSocket"
                                    >
                                    </app-multi-doc-summary-section>
                                </div>
                            </ng-template>
                            <ng-template carouselSlide>
                                <div class="text-end button-mobile-right" *ngIf="!articleExpanded && hideforGyan">
                                    <button
                                        (click)="createGysnBtnClick()"
                                        class="custom-create-gyan-btn float-end"
                                        [attr.id]="'go-creategyantbn'"
                                        [attr.data-test]="'go-creategyantbn'"
                                    >
                                        <div class="create-gyan-plus-icon"></div>
                                        Create Gyan
                                    </button>
                                    <div class="clear"></div>
                                    <!-- <span class="createnewgyanbtn">Create Gyan</span> -->
                                </div>
                                <div class="row h-100">
                                    <div class="col-12 h-100" *ngIf="!articleExpanded && !showArticleNetworkGraph">
                                        <app-articles-section
                                            *ngIf="!clickBackArticleList"
                                            [PreviousGyanId]="PreviousgyanId"
                                            [articleExpanded]="articleExpanded"
                                            (subscriptionMessageModal)="onsubscriptionMessageModal($event)"
                                            [clicbackDataSet]="clicbackDataSet"
                                        >
                                        </app-articles-section>
                                        <app-articles-section
                                            *ngIf="clickBackArticleList"
                                            [PreviousGyanId]="PreviousgyanId"
                                            [clickBackArticleList]="clickBackArticleList"
                                            [articleExpanded]="articleExpanded"
                                            [clickBackparaids]="clickbackparas"
                                            (subscriptionMessageModal)="onsubscriptionMessageModal($event)"
                                        ></app-articles-section>
                                    </div>
                                    <div class="col-12 h-100" *ngIf="articleExpanded">
                                        <div *ngIf="showArticleNetworkGraph">
                                            <div class="search-title search-title-mobile">
                                                <div class="back-arrow-left-network" (click)="articleExpanded = false; showArticleNetworkGraph = false"></div>
                                                <!-- <span class="gyanSearchSectionTitleMobile">{{ GyanName }}</span> -->
                                            </div>
                                            <app-article-network-graph></app-article-network-graph>
                                        </div>
                                        <div *ngIf="!showArticleNetworkGraph">
                                            <div class="search-title search-title-mobile" *ngIf="longStoryData">
                                                <div class="back-arrow-left" (click)="articleExpanded = false; showArticleNetworkGraph = false"></div>
                                                <span class="gyanSearchSectionTitleMobile" title="{{ GyanName }}">{{ GyanName }}</span>
                                            </div>
                                            <app-article-long-story [longStoryData]="longStoryData" [paraClickId]="paraClickId"></app-article-long-story>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </owl-carousel-o>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div #subscriptionMessageModal class="modal fade" tabindex="-1" aria-labelledby="subscriptionMessageModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content text-center">
            <div class="modal-body">
                <div class="text-center d-block">
                    <p class="font-16">
                        You have reached your limit. Do you want to run External Research to get <br />
                        more articles?
                    </p>
                    <div class="row">
                        <div class="col-4 col-sm-2 offset-2 offset-sm-4 text-center mt-4">
                            <button class="btn-custom btn-primary" (click)="closeSubscriptionMessageModal(); moveGyanNameToAdvanceQuery()">Yes</button>
                        </div>
                        <div class="col-4 col-sm-2 text-center mt-4">
                            <button class="btn-custom btn-primary" (click)="closeSubscriptionMessageModal()">No</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Overlay Div -->
<div *ngIf="openStatuspopup" class="modal-overlay" (click)="closeGyanStatusModal()"></div>

<!-- Modal Div -->
<div class="gyanstatus-popup">
    <div [ngClass]="{ 'modal-content': '!isMobile', 'modal-content-mobile': isMobile }" *ngIf="openStatuspopup">
        <div class="text-center d-block">
            <p class="font-14">Your final results for the Gyan are ready. Please confirm to reload the page.</p>
            <div class="d-flex justify-content-evenly">
                <div class="text-center mt-4">
                    <button class="btn-custom btn-primary" (click)="closeGyanStatusModal(); confirmReload()">Confirm</button>
                </div>
                <div class="text-center mt-4">
                    <button class="btn-custom btn-primary" (click)="closeGyanStatusModal()">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #confirmChangesModal let-modal>
    <div class="modal-header confim-header d-flex">
        <div class="modal-title confim-title">Confirm</div>
        <div
            type="button"
            class="gyan-popup-close"
            aria-label="Close"
            (click)="modal.dismiss('Cross click')"
            [attr.id]="'go-delete-gyan-modal-close'"
            [attr.data-test]="'go-delete-gyan-modal-close'"
        >
            <div class="modal-close-icon"></div>
        </div>
    </div>
    <div class="modal-body confim-body text-center confirm-text">
        <div>You didn't submit your last Gyan, Do you want to continue with it?</div>
    </div>
    <div class="modal-footer confim-footer btn-footer mb-2 mt-2">
        <button type="button" class="btn modalactionbtnconfirm" (click)="onConfirmGyan()">Confirm</button>
        <button type="button" class="btn modalactioncancel" (click)="cancelConfirmGyan()">Cancel</button>
    </div>
</ng-template>
